import { getStatusMessage } from './http-error-message'

export class Exception extends Error {
  readonly status: number

  constructor(status: number, message: string) {
    const messageError = getStatusMessage(status, message)
    super(messageError)
    this.status = status
    this.name = ''
  }
}
